
import { mapGetters, mapActions } from 'vuex'
// convert local time to another timezone


export default {
  props: {
    region: {
      type: String,
      default: '',
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showModal: false,
      isOpen: false,
      isSearch:false,
      coursesSub: false,
      jobsSub: false,
      resourcesSub: false,
      onlineSub: false,
      level5Sub: false,
      virtualSub: false,
      classroomSub: false,
      advancedSub: false,
      newToTeflSub: false,
      teoSub: false,
      teaSub: false,
      aboutUsSub: false,
      tzz:'',
      activeCampaign: null,
      // phoneNumber: '0330 808 9138',

    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'user/isLoggedIn',
      label: 'cart/getPriceLabel',
      cart : 'cart/cartProducts',
      totals : 'cart/getTotals',
      timeZone: 'geolocation/detectedTimezone',
      getHours: 'geolocation/getHours',
      detectedRegion: 'geolocation/region',
      detectedCountry: 'geolocation/detectedCountry',
      userRegion: 'user/region',
      activeModal : 'pages/getActiveModal',
    }),
    regionVar() {
      // console.log('COMPUTING REGION FOR MENU TO SHOW...', this.$props.region, this.detectedRegion, this.userRegion);
      const regionVar = this.$props.region
      // const validRegions = ['ca', 'au', 'za']; // Add regions to this as the pages are completed
      const validRegions = [];

      if (validRegions.includes(regionVar)) {
        return '/' + regionVar;
      }

      return '/en-us';
    },
    flag() {
      const fl = this.$nuxt.$options.filters.flagFromLabel(this.label,this.detectedCountry)
      return fl
    },
    flagLink(){
      const fl = this.flag
      if(fl === 'fi-gb'){
        return ''
      } else if(fl === 'fi-ie'){
        return '/ie'
      } else if(fl === 'fi-au'){
        return '/au'
      } else if(fl === 'fi-ca'){
        return '/ca'
      } else if(fl === 'fi-eu'){
        return ''
      } else if(fl === 'fi-za'){
        return '/za'
      } else if(fl === 'fi-us'){
        return '/en-us'
      } else {
        return '/en-us'
      }
    },
    currencyCode() {
      const cc = this.$nuxt.$options.filters.currencyCodeFromLabel(this.label)
      return cc
    },

    itemsInCart(){
     //  const cart = this.$store.getters.cart.cartProducts;
      return this.cart.length
    },
    cartTotal(){
      return this.totals.discounted
    },

  },
  watch: {
    isOpen: {
      immediate: true,
      handler(isOpen) {
        if (process.client) {
          if (isOpen) document.body.style.setProperty('overflow', 'hidden')
          else document.body.style.removeProperty('overflow')
        }
      },
    }
  },


  mounted() {
    document.addEventListener('keydown', (e) => {
      if (e.keyCode === 27 && this.isOpen) this.isOpen = false
    })
  },

  methods: {
    ...mapActions({
      addToCart:'cart/addToCartServer',
      resetCart:'cart/resetCart',
      setHours: 'geolocation/setHours',
      updateActiveModal: 'pages/updateActiveModal',
    }),
    updateModal(id){
        this.updateActiveModal(id)
        console.log('Active Modal: ',this.activeModal)
      },


    showCurrency() {
      this.showModal = true
    },

    drawer() {
      this.isOpen = !this.isOpen
    },

    coursesToggle() {
      this.coursesSub = !this.coursesSub
    },
    newToTeflToggle() {
      this.newToTeflSub = !this.newToTeflSub
    },
    teoToggle(){
      this.teoSub = !this.teoSub
    },
    teaToggle(){
      this.teaSub = !this.teaSub
    },
    jobsToggle() {
      this.jobsSub = !this.jobsSub
    },
    resourcesToggle() {
      this.resourcesSub = !this.resourcesSub
    },
    aboutUsToggle() {
      this.aboutUsSub = !this.aboutUsSub
    },

    onlineToggle() {
      this.level5Sub = false
      this.virtualSub = false
      this.classroomSub = false
      this.advancedSub = false
      this.onlineSub = !this.onlineSub
    },

    level5Toggle() {
      this.onlineSub = false
      this.virtualSub = false
      this.classroomSub = false
      this.advancedSub = false
      this.level5Sub = !this.level5Sub
    },

    virtualToggle() {
      this.onlineSub = false
      this.level5Sub = false
      this.classroomSub = false
      this.advancedSub = false
      this.virtualSub = !this.virtualSub
    },

    classroomToggle() {
      this.onlineSub = false
      this.level5Sub = false
      this.virtualSub = false
      this.advancedSub = false
      this.classroomSub = !this.classroomSub
    },

    advancedToggle() {
      this.onlineSub = false
      this.level5Sub = false
      this.virtualSub = false
      this.classroomSub = false
      this.advancedSub = !this.advancedSub
    },

    async logout() {
      await this.$store.dispatch('user/logout')
      // await this.$store.dispatch('cart/fullReset')
      this.$router.push({ path: '/my-account' })
    },
  },
}
